import styles from './Card.module.css';

type CardProps = {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
};

export function Card({ title, subtitle, children }: CardProps) {
  return (
    <div className={styles.card}>
      {(title || subtitle) && (
        <div className={styles.cardHeader}>
          {title && <h2 className={styles.cardTitle}>{title}</h2>}
          {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
}
